import {
  FontWeights,
  grey,
  ToggleButton,
  ToggleButtonProps,
} from "@faro-lotv/flat-ui";
import { Stack } from "@mui/material";
import { forwardRef, type JSX } from "react";

/** The height of the scene filter toggle. */
export const TOGGLE_HEIGHT = "2.25rem";

/** The size of the icons displayed on the toggle. */
const TOGGLE_ICON_SIZE = "18px";

/** Shared style for the icons used in the buttons */
export const TOGGLE_ICON_SX = Object.freeze({
  width: TOGGLE_ICON_SIZE,
  height: TOGGLE_ICON_SIZE,
  lineHeight: 0,
} as const);

/** @returns A styled toggle button */
export const TypeToggleButton = forwardRef<
  HTMLButtonElement,
  ToggleButtonProps
>(function TypeToggleButton({ children, sx, ...rest }, ref): JSX.Element {
  return (
    <ToggleButton
      sx={{
        textTransform: "none",
        fontSize: "0.875em",
        fontWeight: FontWeights.SemiBold,
        whiteSpace: "nowrap",
        border: 0,
        lineHeight: 0,
        "&.MuiButtonBase-root.MuiToggleButton-root": {
          border: "none",
          m: 0,
          ml: 0,
        },
        height: TOGGLE_HEIGHT,
        ...sx,
      }}
      disabledBackgroundColor={grey[1000]}
      {...rest}
      ref={ref}
    >
      {/* flat-ui wraps the children in a block div, so lay them out in a row here */}
      <Stack direction="row" sx={{ alignItems: "center", gap: 1 }}>
        {children}
      </Stack>
    </ToggleButton>
  );
});
